import { useInterval } from '@autopass-web/domain';
import { useState, useImperativeHandle, forwardRef, useRef } from 'react';
import styles from './index.module.scss';
import classnames from 'classnames/bind';
import SVG from 'react-inlinesvg';
const cx = classnames.bind(styles);

const Timer = ({ countDownSeconds, onRefresh, onTimesUp }, ref) => {
  const [countDownTime, setCountDownTime] = useState(countDownSeconds);
  const [counting, setCounting] = useState(true);
  const timerRef = useRef();

  useImperativeHandle(ref, () => ({
    onRestartCountDown,
    onPauseCountDown: () => setCounting(false),
  }));

  useInterval(
    () => {
      if (countDownTime <= 0) {
        setCounting(false);
        setCountDownTime(0);
        onTimesUp();
      } else {
        setCountDownTime((prev) => prev - 1);
      }
    },
    counting ? 1000 : null,
  );

  const timeClass = cx({
    time: true,
    close: countDownTime <= 10,
  });

  const onRestartCountDown = () => {
    setCountDownTime(countDownSeconds);
    setCounting(true);
  };

  const refresh = () => {
    onRestartCountDown();
    onRefresh();
  };

  return (
    <div className={styles.timer} ref={timerRef}>
      <div className={timeClass}>
        {Math.floor(countDownTime / 60)
          .toString()
          .padStart(2, '0')}
        :{(countDownTime % 60).toString().padStart(2, '0')}
      </div>
      <SVG width={12} height={12} src="/assets/refresh.svg" onClick={refresh} />
    </div>
  );
};

export default forwardRef(Timer);
